/**
 * URL helpers shared by client + server. Photos are LINK-ONLY and never uploaded or stored — we
 * only keep a pasted public image link. isHttpsImageUrl gates that link on both ends.
 *
 * S89 #8: the character class is an EXPLICIT allowlist (RFC3986-ish), not \S+. Quotes, angle
 * brackets, backticks, backslashes and whitespace are rejected outright — the stored-XSS shape
 * if any future surface ever renders a stored URL unescaped.
 */

// Allowed URL characters after the scheme: RFC3986 unreserved + sub-delims + : / ? # @ %
// (leading '-' so it is literal, '.' is literal inside a class).
const SAFE = String.raw`[-A-Za-z0-9._~%/:?#@!$&*+,;=()]`;

const HTTPS_IMAGE_RE = new RegExp(
  String.raw`^https://${SAFE}+\.(jpe?g|png|gif|webp|avif)(\?${SAFE}*)?(#${SAFE}*)?$`,
  'i',
);
const HTTP_URL_RE = new RegExp(String.raw`^https?://${SAFE}+$`, 'i');

/** True for an https URL whose path ends in a common image extension (optional query/hash). */
export function isHttpsImageUrl(url: string | undefined | null): boolean {
  return HTTPS_IMAGE_RE.test((url ?? '').trim());
}

/** True for any http(s) URL (used for the generic "link" field). */
export function isHttpUrl(url: string | undefined | null): boolean {
  return HTTP_URL_RE.test((url ?? '').trim());
}
